import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const FinancingForm = ({ formData, onFormChange, tenorOptions, downPaymentOptions }) => {
  const handleInputChange = (field, value) => {
    onFormChange({ ...formData, [field]: value });
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center space-x-3 mb-4">
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name="Calculator" size={20} color="var(--color-primary)" />
        </div>
        <h3 className="text-lg md:text-xl font-heading font-bold text-foreground">
          Detail Pembiayaan
        </h3>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <Input
          label="Uang Muka (DP)"
          type="number"
          placeholder="Masukkan jumlah DP"
          value={formData?.downPayment}
          onChange={(e) => handleInputChange('downPayment', e?.target?.value)}
          description="Minimal 10% dari harga motor"
          required
        />

        <Select
          label="Pilih DP Cepat"
          placeholder="Atau pilih paket DP"
          options={downPaymentOptions}
          value={formData?.quickDownPayment}
          onChange={(value) => {
            handleInputChange('quickDownPayment', value);
            if (value) {
              handleInputChange('downPayment', value);
            }
          }}
          clearable
        />

        <Select
          label="Tenor Cicilan"
          placeholder="Pilih jangka waktu"
          options={tenorOptions}
          value={formData?.tenor}
          onChange={(value) => handleInputChange('tenor', value)}
          required
        />

        <Input
          label="Nama Lengkap"
          type="text"
          placeholder="Masukkan nama lengkap"
          value={formData?.fullName}
          onChange={(e) => handleInputChange('fullName', e?.target?.value)}
          required
        />

        <Input
          label="Nomor Telepon"
          type="tel"
          placeholder="08xx xxxx xxxx"
          value={formData?.phone}
          onChange={(e) => handleInputChange('phone', e?.target?.value)}
          required
        />

        <Input
          label="Email"
          type="email"
          placeholder="email@example.com"
          value={formData?.email}
          onChange={(e) => handleInputChange('email', e?.target?.value)}
        />
      </div>
      <div className="p-4 bg-muted rounded-lg">
        <div className="flex items-start space-x-3">
          <Icon name="Info" size={20} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
          <div className="flex-1">
            <p className="text-sm font-heading font-semibold text-foreground mb-1">
              Informasi Penting
            </p>
            <ul className="text-sm text-muted-foreground space-y-1">
              <li>• Suku bunga dapat berubah sesuai kebijakan leasing</li>
              <li>• Perhitungan ini bersifat estimasi dan tidak mengikat</li>
              <li>• Untuk informasi lebih detail, hubungi sales kami</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinancingForm;